<template>
  <v-radio-group
    v-model="inputValue"
    v-bind:rules="thaiOrOtherRules"
    :mandatory="false"
    row
  >
    <v-row>
      <v-col cols="12" sm="4">
        <v-radio v-bind:label="textThai" value="thai"></v-radio>
      </v-col>
      <v-col cols="12" sm="4">
        <v-radio v-bind:label="textOther" value="other"></v-radio>
      </v-col>
    </v-row>
  </v-radio-group>
</template>

<script>
import { objectTranslator } from "../../helper/translator";
import validator from "../../helper/validator";
export default {
  name: "ThaiOrOtherCard",
  props: ["textThai", "textOther", "value"],
  methods: {
    objectTranslator,
  },
  data() {
    return {
      thaiOrOtherRules: [validator.required],
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>
